// auth modules
import axios from 'axios';
import Router from '../../router'
import { CHECK_TAKEN, LOGIN_URL, RESET_EMAIL_URL, SEND_VERIFICATION_CODE, SIGNUP_URL, RESET_PASSWORD, CUSTOMER_INFORMATION_URL, CHANGE_PASSWORD } from '../../api/url'

// initial state
const state = {
  loginErrorMessage: '',
  resetEmailMessage: '',
  token: localStorage.getItem('token') || '',
  loggedIn: false,
  userDetails: {},
}

function getHeaderWithToken() {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `JWT ${token}`,
  }
  return headers
}
// actions
const actions = {
  LoginRequest: ({ commit, dispatch }, data) => {
    commit('updateErrorMessage', null)
    axios({url: LOGIN_URL, data, method: 'POST'})
    .then(res => {
      commit('updateToken', res.data.token);
      commit('updateLoginStatus', true);
      dispatch(`fetchCustomerInformation`, res.data.token);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('shareCreditUsed', false);
      Router.push('/');
    })
    .catch(err => {
      commit('updateErrorMessage', err);
    })
  },
  registerRequest: (context, data) => axios({ url: SIGNUP_URL, data, method: 'POST' }),
  checkUsername: (context, data) => axios({ url: CHECK_TAKEN, data, method: 'POST' }),
  checkEmail: (context, data) => axios({ url: CHECK_TAKEN, data, method: 'POST' }),
  checkRecommender: (context, data) => axios({ url: CHECK_TAKEN, data, method: 'POST' }),
  resetEmail: (context, data) => axios({ url: `${RESET_EMAIL_URL}${data}/`, method: 'POST' }),
  sentVerificationCode: (context, data) =>  axios({ url: `${SEND_VERIFICATION_CODE}${data.code}/`,data: {token: data.token}, method: 'POST' }),
  resetPassword: (context, data) => axios({ url: `${RESET_PASSWORD}`, data, method: 'POST' }),
  changePassword: (context, data) => axios({url: `${CHANGE_PASSWORD}`, data, method: 'POST', headers: getHeaderWithToken()}),
  fetchCustomerInformation(context, tokken){
    const token = localStorage.getItem('token') || tokken
    if(!token){
      return
    }
    const config = {
      method: 'get',
      url: CUSTOMER_INFORMATION_URL,
      headers: {
        Authorization: `JWT ${token}`,
      }
    };
    axios(config) 
    .then((response) => {
      context.commit('fetchCustomerInformation', response.data);
    }, (err) => {
      console.log("fetchCustomerInformation error:", err);
    })
  } 
};

// mutations
const mutations = {
  updateToken: (state, token) => {
    state.token = token
  },
  updateErrorMessage: (state, message) => {
    if(message) {
      state.loginErrorMessage = "Unable to login with provided credentials"
    }else {
      state.loginErrorMessage = ""
    }
  },
  updateLoginStatus: (state, status) => {
    state.loggedIn = status;
  },
  logout: (state) => {
    state.loggedIn = false;
    state.token = '';
    localStorage.removeItem('token');
    Router.push('/');
  },
  fetchCustomerInformation(state,payload){
    state.userDetails = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/auth.js